import { render, staticRenderFns } from "./stockIndex.vue?vue&type=template&id=6149811c&scoped=true&"
import script from "./stockIndex.vue?vue&type=script&lang=js&"
export * from "./stockIndex.vue?vue&type=script&lang=js&"
import style0 from "./stockIndex.vue?vue&type=style&index=0&id=6149811c&lang=less&scoped=true&"
import style1 from "./stockIndex.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149811c",
  null
  
)

export default component.exports